export default __webpack_public_path__ + "static/media/shape-56.f6037bcd.png";